// Mesquite Mafia PWA Engine
// Manages Service Worker lifecycle and Native Install Banner

let deferredInstallPrompt = null;

export function initPWA() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
        .then(reg => {
          console.log('[PWA]: Service Worker registered with scope:', reg.scope);
        })
        .catch(err => {
          console.warn('[PWA]: Service Worker registration failed:', err);
        });
    });
  }

  // Intercept beforeinstallprompt for custom native install trigger
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredInstallPrompt = e;
    console.log('[PWA]: Native Install Prompt intercepted and armed.');
    showPWAInstallPrompt();
  });

  window.addEventListener('appinstalled', () => {
    console.log('[PWA]: Mesquite Mafia installed to device.');
    deferredInstallPrompt = null;
    const btn = document.getElementById('pwa-install-banner');
    if (btn) btn.style.display = 'none';
  });
}

export function showPWAInstallPrompt() {
  if (!deferredInstallPrompt) return;

  // Check if banner already exists
  let banner = document.getElementById('pwa-install-banner');
  if (!banner) {
    banner = document.createElement('div');
    banner.id = 'pwa-install-banner';
    banner.style.cssText = `
      position: fixed;
      bottom: 24px;
      right: 24px;
      z-index: 99999;
      background: rgba(14, 16, 22, 0.95);
      border: 1px solid var(--accent-gold, #f59e0b);
      box-shadow: 0 10px 30px rgba(0,0,0,0.8), 0 0 15px rgba(245, 158, 11, 0.3);
      padding: 12px 18px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      gap: 12px;
      backdrop-filter: blur(8px);
      font-family: 'Cinzel', serif;
      animation: fadeInSlideUp 0.4s ease-out;
    `;
    banner.innerHTML = `
      <div style="font-size: 1.3rem;">📲</div>
      <div>
        <div style="font-size: 0.85rem; font-weight: 800; color: var(--accent-gold, #f59e0b); letter-spacing: 0.05em;">INSTALL MESQUITE MAFIA</div>
        <div style="font-size: 0.72rem; color: #94a3b8; font-family: sans-serif;">Fast launch • Offline cache • Native HUD</div>
      </div>
      <button id="pwa-install-confirm-btn" style="
        background: var(--accent-gold, #f59e0b);
        color: #000;
        border: none;
        padding: 6px 14px;
        font-weight: 900;
        font-size: 0.75rem;
        cursor: pointer;
        border-radius: 2px;
        letter-spacing: 0.06em;
      ">INSTALL</button>
      <button id="pwa-install-close-btn" style="
        background: transparent;
        border: none;
        color: #64748b;
        font-size: 1rem;
        cursor: pointer;
        padding: 4px;
      ">✕</button>
    `;
    document.body.appendChild(banner);

    document.getElementById('pwa-install-confirm-btn').addEventListener('click', triggerPWAInstall);
    document.getElementById('pwa-install-close-btn').addEventListener('click', () => {
      banner.style.display = 'none';
    });
  } else {
    banner.style.display = 'flex';
  }
}

export async function triggerPWAInstall() {
  if (!deferredInstallPrompt) return;
  try {
    deferredInstallPrompt.prompt();
    const { outcome } = await deferredInstallPrompt.userChoice;
    console.log(`[PWA]: User install prompt response: ${outcome}`);
    deferredInstallPrompt = null;
    const banner = document.getElementById('pwa-install-banner');
    if (banner) banner.style.display = 'none';
  } catch (err) {
    console.error('[PWA]: Prompt error:', err);
  }
}
